module.exports = __webpack_public_path__ + "img/oee-2.ae0281c9.png";